/**
 * Single source of truth for Y.Doc fragment names used by PageApp_v2.
 *
 * The page: room Y.Doc historically held a 'prosemirror' fragment populated
 * by ProseMirror. The BlockNote editor stores its content in a separate
 * 'blocknote' fragment, keyed here so every reader/writer (client + tool-runtime)
 * agrees on the exact name.
 */

export const PAGE_BN_FRAGMENT = 'blocknote';
